import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IMasterclass {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  background_image?: string;
  left_navigation_icon?: string;
  left_navigation_icon_alt?: string;
  right_navigation_icon?: string;
  right_navigation_icon_alt?: string;
  button_text?: string;
  button_background_color?: string;
  button_text_color?: string;
  button_icon?: string;
  button_icon_alt?: string;
  button_hover_icon?: string;
  button_hover_icon_alt?: string;
  status?: boolean;
  variant?: string;
}

export async function createMasterclass(payload: Partial<IMasterclass>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.MASTERCLASS.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateMasterclass(id: number, payload: Partial<IMasterclass>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.MASTERCLASS.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

